import React, { useState, useEffect } from "react";
import { registrarUsuario } from "../api";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from 'react-hot-toast';
import { validarCodigoReferido } from "../api";

  const CrearCuenta = () => {
  const navigate = useNavigate();
  const [cargando, setCargando] = useState(false);
  const [nombre, setNombre] = useState("");
  const [correo, setCorreo] = useState("");
  const [celular, setCelular] = useState("");
  const [usuario, setUsuario] = useState("");
  const [clave, setClave] = useState("");
  const [placeholderCelular, setPlaceholderCelular] = useState("Ingresa tu número");

    const handleSubmit = async () => {
        if (!nombre || !usuario || !clave) {
          toast.dismiss();
          toast.error("Todos los campos son obligatorios");
          return;
        }
        
        const pais = localStorage.getItem("pais") || "";

        if (cargando) {
            return;
        }

        const os_device = localStorage.getItem("os_device") || "Desconocido";

        setCargando(true);
      
        try {
          const anon_id = localStorage.getItem("anon_id") || null;
          const id_pais = localStorage.getItem("pais") || "";
          const id_departamento = localStorage.getItem("departamento") || "";
      
          const datos = {
            nombre,
            correo,
            celular,
            usuario,
            clave,
            id_pais,
            id_departamento,
            codigo_referido: 0,
            os_device,
            anon_id
          };
      
          const result = await registrarUsuario(datos);
      
          if (result && result.success){
            toast.dismiss();
            toast.success("Tu cuenta se creó exitosamente, ahora puedes acceder.");
            localStorage.removeItem("pais");
            localStorage.removeItem("departamento");
            navigate("/login");
          } else {
            // Mostrar el mensaje que viene del backend si lo hay
            if (result?.error) {
              toast.dismiss();
              toast.error(result.error);
            } else {
              toast.dismiss();
              toast.error('Ocurrió un problema técnico al crear tu cuenta, intenta de nuevo más tarde.');
            }
          }
        } catch (error) {
          toast.dismiss();
          toast.error('Ocurrión un problema técnico al crear tu cuenta, intenta de nuevo más tarde.');
        } finally {
          setCargando(false);
        }
    };      

    useEffect(() => {
      const pais = localStorage.getItem("pais") || "";
      const departamento = localStorage.getItem("departamento");

      if (!pais) {
        toast.dismiss();
        toast.error("Debes seleccionar un país antes de continuar.");
        navigate("/registro", { replace: true });
        return;
      }
  
      if (pais.toLowerCase() === "guatemala" && !departamento) {
        toast.dismiss();
        toast.error("Selecciona un departamento antes de continuar.");
        navigate("/departamento", { replace: true });
      }

      if (pais.toLowerCase() === "guatemala") {
        setPlaceholderCelular("Ej: 55443322");
      } else {
        setPlaceholderCelular("Incluye código de país si aplica");
      }

      document.body.style.overflow = 'auto';
      setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 50);
      return () => {
        document.body.style.overflow = 'hidden';
      };
    }, []);

  return (
    <>
      {cargando && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      {!cargando && (
       <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container">
      <div className="promo-container">
        <div className={`promo-header`}>
        </div>
        <div className="promo-banner">
            <img src='../../assets/images/portada.jpg' alt="Portada" style={{borderRadius:0}}/>
        </div>
        <div className="promo-info" style={{padding: 0}}>
          <div className="login-body">
            <img src="/assets/images/logocap.png" alt="Waze" className="login-logo" />
            <h2>Creemos tu cuenta</h2>
            <p className="light-text mb-5">Completa el formulario para continuar</p>

            <div className="input-group">
              <label>Nombre:</label>
              <input
                  type="text"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  autoCapitalize="words"
                  placeholder="¿Cómo te llamas?"
              />
              </div>

              <div className="input-group">
              <label>Usuario:</label>
              <input
                  type="text"
                  value={usuario}
                  onChange={(e) => setUsuario(e.target.value)}
                  autoCapitalize="none"
                  autoCorrect="off"
                  placeholder="Ingresa tu usuario"
              />
              </div>

              <div className="input-group">
              <label>Contraseña:</label>
              <input
                  type="password"
                  value={clave}
                  onChange={(e) => setClave(e.target.value)}
                  placeholder="Ingresa tu clave"
              />
              </div>
              <button
                type="button"
                className="login-btn"
                onClick={handleSubmit}
                disabled={cargando}
              >
                {cargando ? "Creando cuenta..." : "Finalizar"}
              </button>

            <p className="register-link">
              ¿Ya tienes cuenta? <a href="/login">Ingresa aquí.</a>
            </p>
            <p className="version">Versión 1.0</p>
          </div>
        </div>
      </div>
    </div>
    </motion.div>
    )}
    </>
  );
};

export default CrearCuenta;